import { COMPANY_PHONE_NUMBER, MARKETING_PHONE_NUMBER } from "./constants";

export const handlePhoneLink = () => {
  if (typeof window === "undefined") return COMPANY_PHONE_NUMBER;
  if (window.location.pathname.includes("/lp/")) {
    return MARKETING_PHONE_NUMBER;
  } else return COMPANY_PHONE_NUMBER;
};
